var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGropoolsuccessImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 129,
    viewBox: "0 0 160 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.079,
    cy: 69.7343,
    r: 31.9765,
    fill: "#558223"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14775_9389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9854 72.0188L75.8494 78.8709L90.1731 60.5986",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.4619,
    y: 19.0059,
    width: 3.19818,
    height: 3.73121,
    rx: 0.5,
    transform: "rotate(-10.9119 82.4619 19.0059)",
    fill: "url(#paint0_linear_14775_9389)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132.709,
    y: 98.7393,
    width: 3.19818,
    height: 3.73121,
    rx: 0.5,
    transform: "rotate(29.09 132.709 98.7393)",
    fill: "url(#paint1_linear_14775_9389)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9502,
    y: 123.462,
    width: 3.19818,
    height: 3.73121,
    rx: 0.5,
    transform: "rotate(29.09 42.9502 123.462)",
    fill: "url(#paint2_linear_14775_9389)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1553,
    y: 29.4873,
    width: 1.47561,
    height: 1.72155,
    rx: 0.5,
    fill: "url(#paint3_linear_14775_9389)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130.503,
    y: 17.3066,
    width: 2.71756,
    height: 3.17049,
    rx: 0.5,
    transform: "rotate(27 130.503 17.3066)",
    fill: "url(#paint4_linear_14775_9389)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 126.302,
    y: 31.2285,
    width: 1.47561,
    height: 1.72155,
    rx: 0.5,
    fill: "url(#paint5_linear_14775_9389)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 121.947,
    y: 95.9023,
    width: 1.47561,
    height: 1.72155,
    rx: 0.5,
    fill: "url(#paint6_linear_14775_9389)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 133.766,
    y: 71.0273,
    width: 1.47561,
    height: 1.72155,
    rx: 0.5,
    fill: "url(#paint7_linear_14775_9389)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 150.555,
    y: 48.6406,
    width: 1.47561,
    height: 1.72155,
    rx: 0.5,
    fill: "url(#paint8_linear_14775_9389)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 136.873,
    y: 88.4404,
    width: 1.47561,
    height: 1.72155,
    rx: 0.5,
    fill: "url(#paint9_linear_14775_9389)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 106.487,
    y: 121.288,
    width: 1.47561,
    height: 1.72155,
    rx: 0.5,
    fill: "url(#paint10_linear_14775_9389)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1396,
    y: 23.2812,
    width: 2.10704,
    height: 2.45821,
    rx: 0.5,
    transform: "rotate(-22.65 44.1396 23.2812)",
    fill: "url(#paint11_linear_14775_9389)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4.11621,
    y: 111.109,
    width: 2.10704,
    height: 2.45821,
    rx: 0.5,
    transform: "rotate(17.3473 4.11621 111.109)",
    fill: "url(#paint12_linear_14775_9389)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6533,
    y: 38.0693,
    width: 0.797961,
    height: 0.930955,
    rx: 0.398981,
    transform: "rotate(17.3473 37.6533 38.0693)",
    fill: "url(#paint13_linear_14775_9389)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 119.118,
    y: 43.0439,
    width: 0.797961,
    height: 0.930955,
    rx: 0.398981,
    transform: "rotate(17.3473 119.118 43.0439)",
    fill: "url(#paint14_linear_14775_9389)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 152.075,
    y: 57.3467,
    width: 0.797961,
    height: 0.930955,
    rx: 0.398981,
    transform: "rotate(17.3473 152.075 57.3467)",
    fill: "url(#paint15_linear_14775_9389)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 44.2559,
    y: 96.1309,
    width: 0.797961,
    height: 0.930955,
    rx: 0.398981,
    transform: "rotate(17.3473 44.2559 96.1309)",
    fill: "url(#paint16_linear_14775_9389)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2646,
    y: 8.84082,
    width: 0.797961,
    height: 0.930955,
    rx: 0.398981,
    transform: "rotate(17.3473 15.2646 8.84082)",
    fill: "url(#paint17_linear_14775_9389)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1104,
    y: 68.9854,
    width: 1.51526,
    height: 1.7678,
    rx: 0.5,
    transform: "rotate(17.3473 21.1104 68.9854)",
    fill: "url(#paint18_linear_14775_9389)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0654,
    y: 91.4766,
    width: 1.51526,
    height: 1.7678,
    rx: 0.5,
    transform: "rotate(17.3473 23.0654 91.4766)",
    fill: "url(#paint19_linear_14775_9389)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7441,
    y: 113.164,
    width: 1.51526,
    height: 1.7678,
    rx: 0.5,
    transform: "rotate(17.3473 67.7441 113.164)",
    fill: "url(#paint20_linear_14775_9389)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 93.4521,
    y: 8.21973,
    width: 2.10704,
    height: 2.45821,
    rx: 0.5,
    transform: "rotate(17.3473 93.4521 8.21973)",
    fill: "url(#paint21_linear_14775_9389)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9912,
    y: 29.3623,
    width: 2.71451,
    height: 3.16693,
    rx: 0.5,
    transform: "rotate(17.3473 28.9912 29.3623)",
    fill: "url(#paint22_linear_14775_9389)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 78.666,
    y: 2.8584,
    width: 2.71451,
    height: 3.16693,
    rx: 0.5,
    transform: "rotate(-92.65 78.666 2.8584)",
    fill: "url(#paint23_linear_14775_9389)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 6.41113,
    y: 55.8438,
    width: 4.18585,
    height: 4.88349,
    rx: 0.5,
    transform: "rotate(135.279 6.41113 55.8438)",
    fill: "url(#paint24_linear_14775_9389)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 154.908,
    y: 116.615,
    width: 4.18585,
    height: 4.88349,
    rx: 0.5,
    transform: "rotate(-11.7361 154.908 116.615)",
    fill: "url(#paint25_linear_14775_9389)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14775_9389",
    x: 65.2354,
    y: 59.3486,
    width: 27.6875,
    height: 24.2725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14775_9389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14775_9389",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14775_9389",
    x1: 84.061,
    y1: 19.0059,
    x2: 84.061,
    y2: 22.7371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14775_9389",
    x1: 134.308,
    y1: 98.7393,
    x2: 134.308,
    y2: 102.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14775_9389",
    x1: 44.5493,
    y1: 123.462,
    x2: 44.5493,
    y2: 127.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14775_9389",
    x1: 61.8931,
    y1: 29.4873,
    x2: 61.8931,
    y2: 31.2089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14775_9389",
    x1: 131.862,
    y1: 17.3066,
    x2: 131.862,
    y2: 20.4771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14775_9389",
    x1: 127.04,
    y1: 31.2285,
    x2: 127.04,
    y2: 32.9501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14775_9389",
    x1: 122.685,
    y1: 95.9023,
    x2: 122.685,
    y2: 97.6239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14775_9389",
    x1: 134.503,
    y1: 71.0273,
    x2: 134.503,
    y2: 72.7489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14775_9389",
    x1: 151.292,
    y1: 48.6406,
    x2: 151.292,
    y2: 50.3622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14775_9389",
    x1: 137.611,
    y1: 88.4404,
    x2: 137.611,
    y2: 90.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14775_9389",
    x1: 107.225,
    y1: 121.288,
    x2: 107.225,
    y2: 123.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14775_9389",
    x1: 45.1932,
    y1: 23.2812,
    x2: 45.1932,
    y2: 25.7395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14775_9389",
    x1: 5.16973,
    y1: 111.109,
    x2: 5.16973,
    y2: 113.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14775_9389",
    x1: 38.0523,
    y1: 38.0693,
    x2: 38.0523,
    y2: 39.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14775_9389",
    x1: 119.517,
    y1: 43.0439,
    x2: 119.517,
    y2: 43.9749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14775_9389",
    x1: 152.474,
    y1: 57.3467,
    x2: 152.474,
    y2: 58.2776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14775_9389",
    x1: 44.6548,
    y1: 96.1309,
    x2: 44.6548,
    y2: 97.0618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14775_9389",
    x1: 15.6636,
    y1: 8.84082,
    x2: 15.6636,
    y2: 9.77177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14775_9389",
    x1: 21.868,
    y1: 68.9854,
    x2: 21.868,
    y2: 70.7532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14775_9389",
    x1: 23.8231,
    y1: 91.4766,
    x2: 23.8231,
    y2: 93.2444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14775_9389",
    x1: 68.5018,
    y1: 113.164,
    x2: 68.5018,
    y2: 114.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_14775_9389",
    x1: 94.5057,
    y1: 8.21973,
    x2: 94.5057,
    y2: 10.6779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_14775_9389",
    x1: 30.3485,
    y1: 29.3623,
    x2: 30.3485,
    y2: 32.5292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_14775_9389",
    x1: 80.0233,
    y1: 2.8584,
    x2: 80.0233,
    y2: 6.02533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_14775_9389",
    x1: 8.50406,
    y1: 55.8438,
    x2: 8.50406,
    y2: 60.7272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_14775_9389",
    x1: 157.001,
    y1: 116.615,
    x2: 157.001,
    y2: 121.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53970D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGropoolsuccessImage);
export default __webpack_public_path__ + "static/media/gropoolsuccessImage.445581866b22232626ce77f1d9105cdc.svg";
export { ForwardRef as ReactComponent };